<script>
  export let assetsPath = './';
  let width = null;
  import { onMount } from 'svelte';
  export let onAiMounted = () => {};
  onMount(() => {
    onAiMounted();
  });
</script>

<div id="g-collage-dark-box" bind:clientWidth={width}>
  <!-- Artboard: xs -->
  {#if width && width >= 0 && width < 510}
    <div id="g-collage-dark-xs" class="g-artboard" style="">
      <div style="padding: 0 0 94.5455% 0;"></div>
      <div
        id="g-collage-dark-xs-img"
        class="g-aiImg"
        alt=""
        style="background-image: url({assetsPath.replace(
          new RegExp('/([^/.]+)$'),
          '/$1/'
        ) || '/'}images/graphics/collage-dark-xs.jpg);"
      ></div>
      <div
        id="g-ai0-1"
        class="g-XS g-aiAbs g-aiPointText"
        style="top:5.1956%;margin-top:-10.2px;left:45.7706%;width:176px;"
      >
        <p class="g-pstyle0">Olivier Rousteing, 2024</p>
      </div>
      <div
        id="g-ai0-2"
        class="g-XS g-aiAbs g-aiPointText"
        style="top:13.9135%;margin-top:-17.4px;left:45.7707%;width:138px;"
      >
        <p class="g-pstyle0">Designer: Balmain</p>
      </div>
      <div
        id="g-ai0-3"
        class="g-XS g-aiAbs"
        style="top:10.5769%;left:4.1565%;width:46.0606%;"
      >
        <p>Grimes,</p>
        <p>2021</p>
      </div>
      <div
        id="g-ai0-4"
        class="g-XS g-aiAbs g-aiPointText"
        style="top:21.3474%;margin-top:-18.6px;left:46.5335%;width:118px;"
      >
        <p class="g-pstyle0">Face sculpted</p>
        <p class="g-pstyle0">using sand</p>
      </div>
      <div
        id="g-ai0-5"
        class="g-XS g-aiAbs g-aiPointText"
        style="top:78.6571%;margin-top:-17.4px;left:4.3999%;width:90px;"
      >
        <p class="g-pstyle0">Designers:</p>
      </div>
      <div
        id="g-ai0-6"
        class="g-XS g-aiAbs"
        style="top:79.4872%;left:10.3347%;width:45.1515%;"
      >
        <p>Dress: Iris</p>
        <p>van Herpen</p>
      </div>
      <div
        id="g-ai0-7"
        class="g-XS g-aiAbs"
        style="top:89.4231%;left:10.0407%;width:46.6667%;"
      >
        <p>Sword: Medieval replica by MSCHF</p>
      </div>
    </div>
  {/if}
  <!-- Artboard: sm -->
  {#if width && width >= 510 && width < 660}
    <div id="g-collage-dark-sm" class="g-artboard" style="">
      <div style="padding: 0 0 78.0392% 0;"></div>
      <div
        id="g-collage-dark-sm-img"
        class="g-aiImg"
        alt=""
        style="background-image: url({assetsPath.replace(
          new RegExp('/([^/.]+)$'),
          '/$1/'
        ) || '/'}images/graphics/collage-dark-sm.jpg);"
      ></div>
      <div
        id="g-ai1-1"
        class="g-SM g-aiAbs g-aiPointText"
        style="top:4.5842%;margin-top:-12.2px;left:46.8712%;width:202px;"
      >
        <p class="g-pstyle0">Olivier Rousteing, 2024</p>
      </div>
      <div
        id="g-ai1-2"
        class="g-SM g-aiAbs g-aiPointText"
        style="top:12.7249%;margin-top:-20.6px;left:46.8713%;width:157px;"
      >
        <p class="g-pstyle0">Designer: Balmain</p>
      </div>
      <div
        id="g-ai1-3"
        class="g-SM g-aiAbs"
        style="top:10.3015%;left:0.3366%;width:29.8039%;"
      >
        <p>Grimes, 2021</p>
      </div>
      <div
        id="g-ai1-4"
        class="g-SM g-aiAbs g-aiPointText"
        style="top:19.105%;margin-top:-22px;left:46.8712%;width:134px;"
      >
        <p class="g-pstyle0">Face sculpted</p>
        <p class="g-pstyle0">using sand</p>
      </div>
      <div
        id="g-ai1-5"
        class="g-SM g-aiAbs g-aiPointText"
        style="top:76.2927%;margin-top:-20.6px;left:0.494%;width:102px;"
      >
        <p class="g-pstyle0">Designers:</p>
      </div>
      <div
        id="g-ai1-6"
        class="g-SM g-aiAbs"
        style="top:77.3869%;left:6.8321%;width:29.2157%;"
      >
        <p>Dress: Iris</p>
        <p>van Herpen</p>
      </div>
      <div
        id="g-ai1-7"
        class="g-SM g-aiAbs"
        style="top:88.9447%;left:11.9871%;width:30.1961%;"
      >
        <p>Sword: Medieval replica by MSCHF</p>
      </div>
    </div>
  {/if}
  <!-- Artboard: md -->
  {#if width && width >= 660 && width < 930}
    <div id="g-collage-dark-md" class="g-artboard" style="">
      <div style="padding: 0 0 69.0909% 0;"></div>
      <div
        id="g-collage-dark-md-img"
        class="g-aiImg"
        alt=""
        style="background-image: url({assetsPath.replace(
          new RegExp('/([^/.]+)$'),
          '/$1/'
        ) || '/'}images/graphics/collage-dark-md.jpg);"
      ></div>
      <div
        id="g-ai2-1"
        class="g-MD g-aiAbs g-aiPointText"
        style="top:3.7818%;margin-top:-12.2px;left:46.5217%;width:202px;"
      >
        <p class="g-pstyle0">Olivier Rousteing, 2024</p>
      </div>
      <div
        id="g-ai2-2"
        class="g-MD g-aiAbs"
        style="top:3.7281%;left:1.1692%;width:23.0303%;"
      >
        <p>Grimes, 2021</p>
      </div>
      <div
        id="g-ai2-3"
        class="g-MD g-aiAbs g-aiPointText"
        style="top:10.4485%;margin-top:-20.6px;left:46.5217%;width:157px;"
      >
        <p class="g-pstyle0">Designer: Balmain</p>
      </div>
      <div
        id="g-ai2-4"
        class="g-MD g-aiAbs g-aiPointText"
        style="top:16.4557%;margin-top:-22px;left:46.5217%;width:134px;"
      >
        <p class="g-pstyle0">Face sculpted</p>
        <p class="g-pstyle0">using sand</p>
      </div>
      <div
        id="g-ai2-5"
        class="g-MD g-aiAbs g-aiPointText"
        style="top:75.58%;margin-top:-20.6px;left:2.503%;width:102px;"
      >
        <p class="g-pstyle0">Designers:</p>
      </div>
      <div
        id="g-ai2-6"
        class="g-MD g-aiAbs"
        style="top:77.193%;left:10.1279%;width:22.5758%;"
      >
        <p>Dress: Iris</p>
        <p>van Herpen</p>
      </div>
      <div
        id="g-ai2-7"
        class="g-MD g-aiAbs"
        style="top:87.7193%;left:12.7476%;width:23.3333%;"
      >
        <p>Sword: Medieval replica by MSCHF</p>
      </div>
    </div>
  {/if}
  <!-- Artboard: lg -->
  {#if width && width >= 930 && width < 1200}
    <div id="g-collage-dark-lg" class="g-artboard" style="">
      <div style="padding: 0 0 59.6774% 0;"></div>
      <div
        id="g-collage-dark-lg-img"
        class="g-aiImg"
        alt=""
        style="background-image: url({assetsPath.replace(
          new RegExp('/([^/.]+)$'),
          '/$1/'
        ) || '/'}images/graphics/collage-dark-lg.jpg);"
      ></div>
      <div
        id="g-ai3-1"
        class="g-LG g-aiAbs"
        style="top:1.0811%;left:3.1239%;width:16.3441%;"
      >
        <p>Grimes, 2021</p>
      </div>
      <div
        id="g-ai3-2"
        class="g-LG g-aiAbs g-aiPointText"
        style="top:5.4496%;margin-top:-12.2px;left:49.5031%;width:202px;"
      >
        <p class="g-pstyle0">Olivier Rousteing, 2024</p>
      </div>
      <div
        id="g-ai3-3"
        class="g-LG g-aiAbs g-aiPointText"
        style="top:10.7469%;margin-top:-20.6px;left:49.5031%;width:157px;"
      >
        <p class="g-pstyle0">Designer: Balmain</p>
      </div>
      <div
        id="g-ai3-4"
        class="g-LG g-aiAbs g-aiPointText"
        style="top:15.8627%;margin-top:-22px;left:49.5862%;width:134px;"
      >
        <p class="g-pstyle0">Face sculpted</p>
        <p class="g-pstyle0">using sand</p>
      </div>
      <div
        id="g-ai3-5"
        class="g-LG g-aiAbs g-aiPointText"
        style="top:80.8369%;margin-top:-20.6px;left:6.1135%;width:102px;"
      >
        <p class="g-pstyle0">Designers:</p>
      </div>
      <div
        id="g-ai3-6"
        class="g-LG g-aiAbs"
        style="top:82.5225%;left:13.5677%;width:16.0215%;"
      >
        <p>Dress: Iris</p>
        <p>van Herpen</p>
      </div>
      <div
        id="g-ai3-7"
        class="g-LG g-aiAbs"
        style="top:92.4324%;left:16.3946%;width:16.5591%;"
      >
        <p>Sword: Medieval replica by MSCHF</p>
      </div>
    </div>
  {/if}
  <!-- Artboard: xl -->
  {#if width && width >= 1200}
    <div id="g-collage-dark-xl" class="g-artboard" style="">
      <div style="padding: 0 0 51.6667% 0;"></div>
      <div
        id="g-collage-dark-xl-img"
        class="g-aiImg"
        alt=""
        style="background-image: url({assetsPath.replace(
          new RegExp('/([^/.]+)$'),
          '/$1/'
        ) || '/'}images/graphics/collage-dark-xl.jpg);"
      ></div>
    </div>
  {/if}
</div>
<!-- End ai2html - 2025-05-01 14:24 -->

<!-- Generated by ai2html v0.100.0 - 2025-05-01 14:24 -->
<!-- ai file: collage-dark.ai -->
<style lang="scss">
  #g-collage-dark-box,
  #g-collage-dark-box .g-artboard {
    margin: 0 auto;
  }
  #g-collage-dark-box p {
    margin: 0;
  }
  #g-collage-dark-box .g-aiAbs {
    position: absolute;
  }
  #g-collage-dark-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-collage-dark-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-collage-dark-xs {
    position: relative;
    overflow: hidden;
  }
  #g-collage-dark-xs p {
    font-family: BethEllen-Regular;
    font-weight: 400;
    line-height: 14px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 12px;
    text-align: left;
    color: rgb(0, 0, 0);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-collage-dark-xs .g-pstyle0 {
    height: 14px;
  }
  #g-collage-dark-sm {
    position: relative;
    overflow: hidden;
  }
  #g-collage-dark-sm p {
    font-family: BethEllen-Regular;
    font-weight: 400;
    line-height: 17px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(0, 0, 0);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-collage-dark-sm .g-pstyle0 {
    height: 17px;
  }
  #g-collage-dark-md {
    position: relative;
    overflow: hidden;
  }
  #g-collage-dark-md p {
    font-family: BethEllen-Regular;
    font-weight: 400;
    line-height: 17px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(0, 0, 0);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-collage-dark-md .g-pstyle0 {
    height: 17px;
  }
  #g-collage-dark-lg {
    position: relative;
    overflow: hidden;
  }
  #g-collage-dark-lg p {
    font-family: BethEllen-Regular;
    font-weight: 400;
    line-height: 17px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(0, 0, 0);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-collage-dark-lg .g-pstyle0 {
    height: 17px;
  }
  #g-collage-dark-xl {
    position: relative;
    overflow: hidden;
  }

  /* Custom CSS */
  .g-text {
  }
</style>
